import { render, staticRenderFns } from "./UsergroupPsoGroup.vue?vue&type=template&id=74ba137f"
import script from "./UsergroupPsoGroup.vue?vue&type=script&lang=js"
export * from "./UsergroupPsoGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports